import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { SHARED_FEATURE_KEY } from './+state/shared.state';
import { sharedReducer } from './+state/shared.reducer';
import { provideDataAccessShared } from '@ipensii/shared/data-access-shared';
import { provideEffects } from '@ngrx/effects';
import { sharedEffects } from './+state/shared.effects';
import { provideRouterStore } from '@ngrx/router-store';
import { RouterSelectors } from './+state/router/router.selectors';

export const provideFeatureSharedState: () => EnvironmentProviders = () =>
  makeEnvironmentProviders([
    provideDataAccessShared(),
    provideState(SHARED_FEATURE_KEY, sharedReducer),
    provideRouterStore({ stateKey: RouterSelectors.getRouterState }),
    provideEffects(sharedEffects),
  ]);
